import { render, staticRenderFns } from "./ImprintBlock.vue?vue&type=template&id=478d9c7d"
import script from "./imprintBlock.ts?vue&type=script&lang=js&external"
export * from "./imprintBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports